export function getAllTextNodes(node) {
  var allTextNodes = [];

  function getTextNodes(node) {
    if (node.nodeType == 3) {
      // Text node
      allTextNodes.push(node);
    } else if (node.nodeType == 1) {
      // Element node
      for (var i = 0, len = node.childNodes.length; i < len; ++i) {
        getTextNodes(node.childNodes[i]);
      }
    }
  }

  getTextNodes(node);
  return allTextNodes;
}
